import Warning from '@mui/icons-material/Warning';
import { Tooltip } from '@mui/material';
import { computed, makeObservable } from 'mobx';
import { Filtro } from './Filtro';

export default class FiltroMovimentoDecisao extends Filtro {
    tipo = 'selecao';
    exibicao = 'select';
    selecaoMultipla = true;

    constructor(props) {
        super(props);

        makeObservable(this, {
            label: computed,
            labelMovimento: computed,
            labelDecisao: computed,
            carregandoDadosComplementares: computed
        });
    }

    get label() {
        return this.labelMovimento && this.labelDecisao
            ? this.labelMovimento + '/' + this.labelDecisao
            : this.labelMovimento || this.labelDecisao;
    }

    get labelMovimento() {
        return this.store.existeSessaoPJe ? 'Movimentos CNJ' : undefined;
    }

    get labelDecisao() {
        return this.store.rootStore.parametroStore.isOrgaoTST && this.store.existeSessaoSIJ ? 'Decisão' : undefined;
    }

    getValorOpcao(registro) {
        if (registro?.movimentos && registro.movimentos.length > 0) {
            return registro.movimentos;
        }

        if (
            registro?.informacaoProcessoSalaSessao?.decisao &&
            Object.keys(registro.informacaoProcessoSalaSessao.decisao).length > 0
        ) {
            return [registro.informacaoProcessoSalaSessao.decisao];
        }
    }

    getDescricao(valor) {
        if (valor.id) {
            return `${valor.id} - ${valor.descricao}`;
        }
        if (valor.numeroMovimentoCnj) {
            let movimentoOriginal = this.store.rootStore.dominioStore.movimentoOriginal(valor.numeroMovimentoCnj);
            return valor.numeroMovimentoCnj + (movimentoOriginal ? ' - ' + movimentoOriginal.descricao : '');
        }
        return '';
    }

    // eslint-disable-next-line no-unused-vars
    getIconeOpcao(registro, valor) {
        if (
            registro?.informacaoProcessoSalaSessao?.decisao &&
            registro.informacaoProcessoSalaSessao.decisao.ativo === false
        ) {
            return (
                <Tooltip
                    placement="top"
                    title="Código inativo"
                >
                    <Warning style={{ fill: 'darkorange' }} />
                </Tooltip>
            );
        }
    }

    getCorOpcao(registro) {
        if (
            registro?.informacaoProcessoSalaSessao?.decisao &&
            registro.informacaoProcessoSalaSessao.decisao.ativo === false
        ) {
            return 'orange';
        }

        return 'black';
    }

    equals(valor1, valor2) {
        if (valor1 && valor2) {
            return (
                (this.isValoresDecisoes(valor1, valor2) && valor1.id === valor2.id) ||
                (this.isValoresMovimentos(valor1, valor2) && valor1.numeroMovimentoCnj === valor2.numeroMovimentoCnj)
            );
        }
        return false;
    }

    isValoresMovimentos(valor1, valor2) {
        return valor1.numeroMovimentoCnj && valor2.numeroMovimentoCnj;
    }

    isValoresDecisoes(valor1, valor2) {
        return valor1.id && valor2.id;
    }

    sort(opcao1, opcao2) {
        let valor1 = opcao1.valor.id || opcao1.valor.numeroMovimentoCnj;
        let valor2 = opcao2.valor.id || opcao2.valor.numeroMovimentoCnj;
        return valor1 > valor2 ? 1 : -1;
    }

    get carregandoDadosComplementares() {
        return this.store.carregandoMovimentosDecisoes;
    }

    renderCarregando() {
        return this.renderCircularProgress(this.label + ' dos processos');
    }
}
